import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'
import { BagDrawer } from '@/components/generals/bag-drawer'
import { BagToast } from '@/components/generals/bag-toast'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-espresso focus:px-5 focus:py-3 focus:text-sm focus:text-ivory'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
            <BagDrawer />
            <BagToast />

            <div aria-hidden='true' className='grain-overlay pointer-events-none fixed inset-0 z-[80]' />
        </div>
    )
}
